import React from 'react'
import { map } from 'lodash'
import { MTableActions } from '@material-table/core'
import { User, AdminResourceType, ClientAdminResourceType } from '@shared/types'

import { Resource } from './admin-generic.types'
import { AdminGenericResetPassword } from './admin-generic-reset-password.component'
import { AdminGenericDidUserLoggedIn } from './admin-generic-did-user-logged-in.component'
/**
 * @todo make `Crud` a const and use it also in admin-generic.utils
 */

export const RESOURCES: Resource[] = [
  {
    id: AdminResourceType.USERS,
    singular: 'user',
    dto: 'User',
    endpoint: 'users',
    table: {
      company: {
        field: 'company.name',
        title: 'Firma',
      },
      userRoles: {
        field: 'userRole',
        title: 'Rola',
        defaultGroupOrder: 0,
      },
    },
    components: {
      Actions: (props: { data: User }) => (
        <div style={{ display: 'flex' }}>
          {props.data ? (
            <>
              <AdminGenericDidUserLoggedIn
                isNotYetLoggedIn={props?.data?.isNotYetLoggedIn}
              />
              <AdminGenericResetPassword email={props?.data?.email} />
            </>
          ) : null}
          <MTableActions {...props} />
        </div>
      ),
    },
    parseData: (data: User[]) =>
      data.map((user) => ({
        ...user,
        companies: user.companies?.map(({ name }) => name).join(', '),
        userRole: user.userRoles?.map(({ roleName }) => roleName).join(', '),
      })),
  },
  /**
   * @todo CRUD is missing
   */
  {
    id: AdminResourceType.COMPANIES,
    singular: 'company',
    dto: 'Company',
    endpoint: 'companies',
  },
  {
    id: AdminResourceType.ROLES,
    singular: 'role',
    dto: 'Role',
    endpoint: 'roles',
  },
  {
    id: AdminResourceType.SCOPES,
    singular: 'scope',
    dto: 'ScopeCrud',
    endpoint: 'scopes/crud',
    table: {
      order: {
        field: 'order',
        title: 'Pozycja',
        width: 150,
      },
      name: {
        field: 'name',
        title: 'Nazwa Zakresu',
        width: 400,
      },
      // todo: add external scope
    },
  },
  {
    id: AdminResourceType.GROUPS,
    singular: 'group',
    dto: 'GroupCrud',
    endpoint: 'groups/crud',
    table: {
      order: {
        field: 'order',
        title: 'Pozycja',
        width: 150,
      },
      scope: {
        field: 'scope.name',
        title: 'Zakresy',
        width: 400,
      },
    },
  },
  {
    id: AdminResourceType.STATUSES,
    singular: 'status',
    dto: 'StatusBase',
    endpoint: 'statuses',
  },
  {
    id: AdminResourceType.TEMPLATES,
    singular: 'template',
    dto: 'DescriptionTemplateCrud',
    endpoint: 'templates/crud',
  },
  {
    id: AdminResourceType.REQUIREMENTS,
    singular: 'requirement',
    dto: 'RequirementBaseCrud',
    endpoint: 'requirementbase/crud',
  },
  {
    id: AdminResourceType.LEGAL_BASIS,
    singular: 'legalbasis',
    dto: 'LegalBasisCrud',
    endpoint: 'legalbasis/crud',
  },
  {
    id: AdminResourceType.LEGAL_BASIS_TYPE,
    singular: 'legalbasistype',
    dto: 'LegalBasisType',
    endpoint: 'legalbasis/types',
    lookup: true,
  },
  {
    id: AdminResourceType.SUMMARY_TEMPLATES,
    singular: 'summaryTemplate',
    dto: 'SummaryTemplateCrud',
    endpoint: 'templates/crud',
    lookup: true,
  },
  {
    id: ClientAdminResourceType.USERS,
    singular: 'user',
    dto: 'User',
    endpoint: 'users/own',
    table: {
      companies: {
        field: 'companies',
        title: 'Firma',
      },
    },
    components: {
      Actions: (props: { data: User }) => (
        <div style={{ display: 'flex' }}>
          {props.data ? (
            <AdminGenericResetPassword email={props?.data?.email} />
          ) : null}
          <MTableActions {...props} />
        </div>
      ),
    },
    parseData: (data: User[]) =>
      data.map((user) => {
        return {
          ...user,
          companies: user.companies
            ?.filter((company) => !!company)
            .map(({ name }) => name)
            .join(', '),
        }
      }),
  },
]

export const ALLOWED_RESOURCES = map(RESOURCES, 'id')
